import * as React from 'react';
import { useCallback, useMemo } from 'react';
import cn from 'classnames';

import { DatepickerProps } from '../../../../../../../Datepicker/components/Datepicker';
import { EngineTheme, ThemeProvider, useTheme } from '../../../../../../../theme';
import { mergeCSS } from '../../../../../../../utils';
import { Datepicker as DatepickerComponent } from '../../../../../../../Datepicker';
import { useRenderers } from '../../../../../../../renderProps';

export interface Props extends DatepickerProps {
	availableDates: Date[];
	renderFooter?: React.Factory<Props>;
}

const Datepicker: React.FC<Props> = props => {
	const { Datepicker: theme } = useTheme('Exchange');

	const datepickerTheme = useTheme('Datepicker');
	const defaultDatepickerTheme = useTheme('SearchFormDatepicker');

	const baseDatepickerTheme: EngineTheme = {
		Datepicker: { ...datepickerTheme }
	};

	const searchDatepickerTheme: EngineTheme = {
		Datepicker: {
			...defaultDatepickerTheme,
			PopupDatepickerStyles: { block: theme.monthsWrapperStyles_wrapper },
			WeeklyHeaderStyles: {
				...defaultDatepickerTheme.WeeklyHeaderStyles,
				dayOfWeekName: defaultDatepickerTheme.WeeklyHeaderStyles.dayOfWeekName_withPrices
			},
			MonthStyles: {
				...defaultDatepickerTheme.MonthStyles,
				week: cn(defaultDatepickerTheme.MonthStyles.week_withPrice, theme.week),
				monthWrapper: cn(defaultDatepickerTheme.MonthStyles.monthWrapper, theme.monthWrapper)
			},
			DayStyles: {
				...defaultDatepickerTheme.DayStyles,
				day: cn(defaultDatepickerTheme.DayStyles.day_withPrice, theme.day),
				day_selected: cn(defaultDatepickerTheme.DayStyles.day_selected, theme.day_selected),
				day_today: cn(defaultDatepickerTheme.DayStyles.day_today, theme.day_today),
				day_endHover: defaultDatepickerTheme.DayStyles.day_endHover_withPrice,
				day_startHover: defaultDatepickerTheme.DayStyles.day_startHover_withPrice,
				day_notAvailable: cn(defaultDatepickerTheme.DayStyles.day_notAvailable, theme.day_notAvailable)
			}
		}
	};

	const mergedDatepickerTheme = useMemo(() => {
		return mergeCSS(baseDatepickerTheme, searchDatepickerTheme);
	}, [baseDatepickerTheme, searchDatepickerTheme]);

	const dayWithPrice = useCallback(
		(date: Date) => <div className={defaultDatepickerTheme.DayStyles.day_hasPrice}>{date.getDate()}</div>,
		[defaultDatepickerTheme]
	);

	const { DatepickerFromRefund: Datepicker = DatepickerComponent } = useRenderers();

	return (
		<ThemeProvider value={mergedDatepickerTheme}>
			<Datepicker
				{...props}
				highlightedDates={{ [theme.day_highlight]: props.availableDates }}
				dayRenderer={dayWithPrice}
			/>
			{props.renderFooter && props.renderFooter(props)}
		</ThemeProvider>
	);
};

export default Datepicker;
